import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import axios from "axios";
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import { format } from "../../intl.js";
import { fetchAllInvoicesWithFilters } from "../../api/index";

import moment from "moment";
import {
  getProfilesByUser,
  updateProfile,
  getProfile,
} from "../../actions/profile";

import {
  useMediaQuery,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Paper,
  IconButton,
  Container,
  TextField,
  CircularProgress,
  FormControl,
  makeStyles,
  useTheme,
  createTheme,
  ThemeProvider,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import PropTypes from "prop-types";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import ClearIcon from "@material-ui/icons/Clear";
import { getAllClients } from "../../actions/clientActions";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import RemoveRedEyeOutlinedIcon from "@material-ui/icons/RemoveRedEyeOutlined";
import Autocomplete from "@material-ui/lab/Autocomplete";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { useLocation } from "react-router-dom";

import ProgressButton from "react-progress-button";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  deleteInvoice,
  getInvoicesByUser,
  getInvoices,
  getInvoicesByPage,
  startGroupDownload,
} from "../../actions/invoiceActions";
import { GROUP_DOWNLOAD_JOB_RESET } from "../../actions/constants";
import GroupDownloadDialog from "../GroupDownload/GroupDownloadDialog";

import {} from "../../actions/invoiceActions";

import { getUsers } from "../../actions/auth";
import NoData from "../svgIcons/NoData";
import Spinner from "../Spinner/Spinner";
import { useSnackbar } from "react-simple-snackbar";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import GetAppIcon from "@material-ui/icons/GetApp";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  // rowsPerPage === -1 is the "All" option — everything fits on one page.
  const totalPages = rowsPerPage > 0 ? Math.ceil(count / rowsPerPage) : 1;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, totalPages - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= totalPages - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= totalPages - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles((theme) => ({
  table: {
    width: "100%",
    minWidth: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
  },

  tablecell: {
    fontSize: "16px",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "20px",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  typography: {
    fontSize: "18px",
    fontWeight: 500,
  },
  summaryPanel: {
    backgroundColor: "#f8fafc",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    padding: theme.spacing(2.5),
    margin: theme.spacing(2, 0),
    boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1.5),
    },
  },
  summaryTitle: {
    color: "#1f2933",
    fontSize: 20,
    fontWeight: 700,
    margin: "0 0 18px",
  },
  summaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(180px, 1fr))",
    gap: 16,
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(2, minmax(160px, 1fr))",
    },
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
      gap: 12,
    },
  },
  summaryCard: {
    backgroundColor: "#ffffff",
    border: "1px solid #dbe2ea",
    borderRadius: 6,
    minHeight: 78,
    padding: theme.spacing(1.5, 2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  summaryLabel: {
    color: "#3f4a58",
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 10,
    textAlign: "center",
  },
  summaryValue: {
    fontSize: 20,
    fontWeight: 800,
    lineHeight: 1.15,
    textAlign: "center",
    wordBreak: "break-word",
    [theme.breakpoints.down("xs")]: {
      fontSize: 18,
    },
  },
  tableContainer: {
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    overflowX: "auto",
    boxShadow: "0 10px 24px rgba(15, 23, 42, 0.07)",
  },
  headCell: {
    backgroundColor: "#f3f6f9",
    color: "#263241",
    borderBottom: "1px solid #dbe2ea",
    fontSize: 14,
    fontWeight: 700,
    padding: "14px 12px",
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  bodyCell: {
    color: "#263241",
    borderBottom: "1px solid #edf1f5",
    fontSize: 14,
    padding: "10px 12px",
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  amountCell: {
    fontWeight: 700,
  },
  row: {
    transition: "background-color 160ms ease",
    "&:hover": {
      backgroundColor: "#fff7ed",
    },
  },
  actionCell: {
    width: 56,
    minWidth: 56,
  },
}));

const headerStyle = {
  borderBottom: "1px solid #dbe2ea",
  textAlign: "center",
  fontSize: "14px",
  fontWeight: 700,
  backgroundColor: "#f3f6f9",
  color: "#263241",
  padding: "14px 12px",
  whiteSpace: "nowrap",
};
const colorTheme = createTheme({
  palette: {
    primary: {
      main: "#ef7f1a",
    },
  },
});

const Invoices = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [downloadStatus, setDownloadStatus] = useState(null);
  const user = JSON.parse(localStorage.getItem("profile"));
  const companyLogo = user?.userProfile?.logo;
  const { invoices, totalInvoices, totalPages } = useSelector(
    (state) => state.invoices.invoices
  );

  // //(invoices);
  const [rows, setRows] = useState([]);
  const { users } = useSelector((state) => state.auth);
  const { profiles } = useSelector((state) => state.profiles);
  const clients = useSelector((state) => state.clients.clients);
  // //(users);
  // //(rows);
  const [loading, setLoading] = useState(false);
  const [groupLoading, setGroupLoading] = useState(false);
  const [groupDialogOpen, setGroupDialogOpen] = useState(false);
  const groupDownloadJob = useSelector((state) => state.groupDownloadJob);
  const isLoading = useSelector((state) => state.invoices.isLoading);
  const [searchQuery, setSearchQuery] = useState("");
  const [salesperson, setSalesperson] = useState(null);
  const [party, setParty] = useState(null);
  // eslint-disable-next-line
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [startDate, setStartDate] = useState(moment().toDate());
  const [endDate, setEndDate] = useState(moment().toDate());
  const [selectedFilter, setSelectedFilter] = useState("");
  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);


  // const rows = []

  // useEffect(() => {
  //     dispatch(getInvoices());
  // }, [dispatch]);

  useEffect(() => {
    dispatch(getInvoicesByPage(page, rowsPerPage, startDate, endDate, salesperson?._id, party?.agentCode, searchQuery, selectedFilter));
  }, [dispatch, page, rowsPerPage, startDate, endDate, salesperson, party, searchQuery, selectedFilter]);

  useEffect(() => {
    setPage(0); // Reset to first page when dates or filters change
  }, [startDate, endDate, salesperson, party, selectedFilter]);
  useEffect(() => {
    // Reopen the progress dialog if a job is already active/finished when this
    // page (re)mounts, e.g. the user navigated away and came back.
    if (groupDownloadJob.jobId && groupDownloadJob.status) {
      setGroupDialogOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setRows(invoices || []);
  }, [invoices]);
  useEffect(() => {
    dispatch(getUsers());
  }, [location]);
  useEffect(() => {
    // dispatch(getProfilesByUser({ search: user?.result?._id }))
    dispatch(getProfile(user?.userProfile?._id));
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(
      // getClientsByUser({ search: user?.result._id || user?.result?.googleId })
      getAllClients()
    );

    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    console.log("Invoices Booking Data Per Page... ------------:", invoices);
  }, [invoices]);

  useEffect(() => {
    console.log("Invoices Booking Total Data... ------------:", totalInvoices);
  }, [totalInvoices]);
  const toNumber = (value) => Number(String(value || 0).replace(/,/g, ""));
  const toCommas = (value) => {
    return toNumber(value).toLocaleString("en-IN");
  };
  // useEffect(() => {
  //   if (user?.result?.userType === "user") {
  //     const rows = invoices.filter(
  //       (inv) => inv.creator[0] === user?.result?._id
  //     );
  //     setRows( rows.filter(filterByDateRange));
  //   } else {
  //     setRows(invoices.filter(filterByDateRange));
  //   }
  // }, );
  const findUserNameById = (userId) => {
    // //("parameter" + userId);
    const user = users.find((user) => user._id == userId);
    // //(user);
    return user ? user.name : "";
  };

  const filterByDateRange = (invoice) => {
    if (!startDate || !endDate || !moment(startDate).isValid() || !moment(endDate).isValid()) {
      return true; // Show all invoices if dates are invalid or not set
    }
    const invoiceDate = moment(invoice.date).startOf('day');
    const start = moment(startDate).startOf('day');
    const end = moment(endDate).startOf('day');
    return invoiceDate.isBetween(start, end, 'day', '[]') || invoiceDate.isSame(start, 'day') || invoiceDate.isSame(end, 'day');
  };


  // Since filtering is now handled server-side, use rows directly
  const filteredRows = rows;
  const summaryCurrency = filteredRows.find((row) => row.currency)?.currency || "฿";
  const summaryTotals = React.useMemo(
    () =>
      filteredRows.reduce(
        (totals, row) => ({
          commission: totals.commission + toNumber(row.commission),
          expense: totals.expense + toNumber(row.expense),
          amount: totals.amount + toNumber(row.total),
        }),
        { commission: 0, expense: 0, amount: 0 }
      ),
    [filteredRows]
  );
  const summaryCards = [
    {
      label: "Commission",
      value: summaryTotals.commission,
      color: "#ff6500",
    },
    {
      label: "Expense",
      value: summaryTotals.expense,
      color: "#e52f4f",
    },
    {
      label: "Amount",
      value: summaryTotals.amount,
      color: "#0b72ff",
    },
  ];

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleFilterChange = (event) => {
    setSelectedFilter(event.target.value); // Update the selected filter when the user changes the option
    // Clear any prior User/Agent selection so switching to FIT/GROUP (or
    // between User and Agent) doesn't carry over a stale creator/agentCode filter.
    setSalesperson(null);
    setParty(null);
    setSearchQuery("");
  };
  const editInvoice = (id) => {
    history.push(`/edit/invoice/${id}`);
  };
  const handleDelete = (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this client?"
    );
    if (confirmDelete) {
      dispatch(deleteInvoice(id, openSnackbar));
    }
  };

  const openInvoice = (id) => {
    history.push(`/invoice/${id}`);
  };
  const createAndDownloadXlsx = async () => {
    setLoading(true);
    try {
      // Fetch all invoices with current filters
      const { data } = await fetchAllInvoicesWithFilters(startDate, endDate, salesperson?._id, party?.agentCode, searchQuery, selectedFilter);
      const allRows = data.invoices;

      if (allRows.length) {
        // Determine unique items from selling array across all rows
        const uniqueItems = [...new Set(allRows.flatMap(row =>
          row.selling.map(item => item.itemName)
        ))];

        // Prepare the data for Excel export
        const exportData = allRows.map(row => {

          // Compute Expense Description
        const expenseDescription = row.payable.map((item, index) => {
          const total = Number(item.unitPrice) * Number(item.quantity);
          return `(${index + 1}) ${item.itemName}, Total: ${total}`;
        }).join('\n');

        // Compute Commission Description
        const commissionDescription = row.selling.map((item, index) => {
          const total = Number(item.unitPrice) * Number(item.quantity);
          return `(${index + 1}) ${item.itemName}, Total: ${total}`;
        }).join('\n');
          // Create a base object with standard columns
          const baseData = {
            'Booking No': row.invoiceNumber || '',
            'Date': row.date ? moment(row.date).format("DD-MM-YYYY") : '',
            'Agent': row.client.name || '',
            'Ref No' : row.refNum || '',
            'Nationality': row.nationality || '',
            'Hotel': row.hotel || '',
            'Booking Type': row.bookingType || '',
            'Guide Name': row.guide || '',
            'Notes': row.notes || '',
            'Pax': (row.adult + row.child) || '',
            'Commission': row.commission || '',
          'Commission Description': commissionDescription || '' ,// New column
            'Expense': row.expense || '',
            'Expense Description': expenseDescription || '', // New column
            'Amount': row.total || '',
            'Guest Code': row.guestCode || '',
            'Adult': row.adult || '',
            'Child': row.child || ''
          };

          // Add dynamic columns for selling items
          uniqueItems.forEach(itemName => {
            const matchedItem = row.selling.find(item => item.itemName === itemName);
            baseData[itemName] = matchedItem ? matchedItem.quantity : '';
          });

          return baseData;
        });

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);

        // Style for headers
        const headerStyle = {
          fill: { fgColor: { rgb: 'D3D3D3' } }, // Light grey background
          font: {
            color: { rgb: '#000000' }, // White text
            bold: true // Optional: make headers bold
          },
          alignment: { horizontal: 'center' } // Optional: center align headers
        };

        const dateStyle = {
          numFmt: 'dd-mm-yyyy'
        };

        const descriptionStyle = {
          alignment: { wrapText: true } // Enable text wrapping for descriptions
        };

        // Apply styles and calculate column widths
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        const colWidths = [];

        for (let col = range.s.c; col <= range.e.c; col++) {
          const headerCell = XLSX.utils.encode_cell({ r: 0, c: col });
          if (worksheet[headerCell]) {
            worksheet[headerCell].s = headerStyle;
          }

          // Apply date style to 'Date' column (column index 1)
          if (col === 1) {
            for (let row = 1; row <= range.e.r; row++) {
              const cell = XLSX.utils.encode_cell({ r: row, c: col });
              if (worksheet[cell]) {
                worksheet[cell].s = dateStyle;
              }
            }
          }

          // Apply description style to 'Expense Description' and 'Commission Description' columns
          const headerValue = worksheet[XLSX.utils.encode_cell({ r: 0, c: col })].v;
          if (headerValue === 'Expense Description' || headerValue === 'Commission Description') {
            for (let row = 1; row <= range.e.r; row++) {
              const cell = XLSX.utils.encode_cell({ r: row, c: col });
              if (worksheet[cell]) {
                worksheet[cell].s = descriptionStyle;
              }
            }
          }

          // Calculate max width for each column
          let maxWidth = String(headerValue).length;
          for (let row = 1; row <= range.e.r; row++) {
            const cell = XLSX.utils.encode_cell({ r: row, c: col });
            if (worksheet[cell] && worksheet[cell].v) {
              const cellValue = String(worksheet[cell].v);
              const lines = cellValue.split('\n');
              const maxLineLength = Math.max(...lines.map(line => line.length));
              maxWidth = Math.max(maxWidth, maxLineLength);
            }
          }
          colWidths.push({ wch: Math.min(maxWidth + 2, 50) }); // Limit max width to 50 characters
        }

        // Set column widths
        worksheet['!cols'] = colWidths;

        // Create workbook and save
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Booking Report');

        const currentDate = new Date();
        const filename = `BookingReport_${currentDate.toISOString().split('T')[0]}.xlsx`;

        XLSX.writeFile(workbook, filename);
        openSnackbar("Export successful");
      } else {
        openSnackbar("No records to export");
      }
    } catch (error) {
      console.error("Export failed", error);
      openSnackbar("Export failed");
    } finally {
      setLoading(false);
    }
  };
  // const createAndDownloadPdf = () => {
  //   //(rows);
  //   //(filteredRows);
  //   setLoading(true);

    
  //   if (filteredRows.length) {
  //     setDownloadStatus("loading");
  //     // Enhance filteredRows with expense and commission descriptions
  //   const enhancedRows = filteredRows.map(row => ({
  //     ...row,
  //     expenseDescription: row.payable.map((item, index) => {
  //       const total = Number(item.unitPrice) * Number(item.quantity);
  //       return `(${index + 1}) ${item.itemName}, Total: ${total}`;
  //     }).join('\n'),
  //     commissionDescription: row.selling.map((item, index) => {
  //       const total = Number(item.unitPrice) * Number(item.quantity);
  //       return `(${index + 1}) ${item.itemName}, Total: ${total}`;
  //     }).join('\n')
  //   }));
  //     axios
  //       .post(`${process.env.REACT_APP_API}/create-report`, {
  //         filteredRows: enhancedRows,
  //         users,
  //         searchQuery,
  //         profiles: profiles,
  //         startDate,
  //         endDate
  //         // totalAmount,
  //       })
  //       .then(() =>
  //         axios.get(`${process.env.REACT_APP_API}/fetch-report`, {
  //           responseType: "blob",
  //         })
  //       )
  //       .then((res) => {
  //         const pdfBlob = new Blob([res.data], { type: "application/pdf" });
  //         // const downloadUrl = window.URL.createObjectURL(pdfBlob);
  //         // setDownloadStatus("success");
  //         // window.open(downloadUrl, "_blank");
  //         const currentDate = new Date();

  //         saveAs(pdfBlob, `BookingReport${currentDate}.pdf`);
  //         const downloadUrl = `${process.env.REACT_APP_URL}/files/Exported-Reports/report.pdf`;
  //         window.open(downloadUrl, "_blank");
  //         setLoading(false);
  //         setDownloadStatus("success");
  //       });
  //   } else {
  //     openSnackbar("No record to Export");
  //   }
  // };
  
  const createAndDownloadPdf = async () => {
    setLoading(true);

    try {
      // Fetch all invoices with current filters
      const { data } = await fetchAllInvoicesWithFilters(startDate, endDate, salesperson?._id, party?.agentCode, searchQuery, selectedFilter);
      const allRows = data.invoices;

      if (allRows.length) {
        setDownloadStatus("loading");
        // Enhance allRows with expense and commission descriptions
        const enhancedRows = allRows.map(row => ({
          ...row,
          expenseDescription: row.payable.map((item, index) => {
            const total = Number(item.unitPrice) * Number(item.quantity);
            return `(${index + 1}) ${item.itemName}, Total: ${total}`;
          }).join('\n'),
          commissionDescription: row.selling.map((item, index) => {
            const total = Number(item.unitPrice) * Number(item.quantity);
            return `(${index + 1}) ${item.itemName}, Total: ${total}`;
          }).join('\n')
        }));

        // Log raw and formatted dates for debugging
        console.log("Raw startDate:", startDate, "Type:", typeof startDate);
        console.log("Raw endDate:", endDate, "Type:", typeof endDate);
        console.log("startDate isValid:", startDate ? moment(startDate).isValid() : false);
        console.log("endDate isValid:", endDate ? moment(endDate).isValid() : false);

        // Format startDate and endDate
        const formattedStartDate = startDate && moment(startDate).isValid()
          ? moment(startDate).format("DD-MM-YYYY")
          : "N/A";
        const formattedEndDate = endDate && moment(endDate).isValid()
          ? moment(endDate).format("DD-MM-YYYY")
          : "N/A";

        console.log("Formatted startDate:", formattedStartDate);
        console.log("Formatted endDate:", formattedEndDate);

        axios
          .post(`${process.env.REACT_APP_API}/create-report`, {
            filteredRows: enhancedRows,
            users,
            searchQuery,
            profiles: profiles,
            startDate: formattedStartDate,
            endDate: formattedEndDate
          })
          .then(() =>
            axios.get(`${process.env.REACT_APP_API}/fetch-report`, {
              responseType: "blob",
            })
          )
          .then((res) => {
            const pdfBlob = new Blob([res.data], { type: "application/pdf" });
            const currentDate = new Date();
            saveAs(pdfBlob, `BookingReport${currentDate}.pdf`);
            const downloadUrl = `${process.env.REACT_APP_URL}/files/Exported-Reports/report.pdf`;
            window.open(downloadUrl, "_blank");
            setLoading(false);
            setDownloadStatus("success");
          })
          .catch((error) => {
            console.error("PDF export failed", error);
            openSnackbar("PDF export failed");
            setLoading(false);
            setDownloadStatus("error");
          });
      } else {
        openSnackbar("No record to Export");
        setLoading(false);
      }
    } catch (error) {
      console.error("Fetch failed", error);
      openSnackbar("Failed to fetch data");
      setLoading(false);
    }
  };

  const handleGroupDownload = async () => {
    const payload = {
      startDate,
      endDate,
      salesperson: salesperson?._id,
      party: party?.agentCode,
      searchQuery,
      selectedFilter,
      logo: companyLogo || "",
    };

    try {
      setGroupLoading(true);
      await dispatch(startGroupDownload(payload, openSnackbar));
      setGroupDialogOpen(true);
    } catch (err) {
      console.error(err);
    } finally {
      setGroupLoading(false);
    }
  };

  const handleCloseGroupDialog = () => {
    setGroupDialogOpen(false);
    // Only clear the job once it's actually finished. A still-processing job
    // is left in Redux on purpose so the mount effect above can reopen this
    // dialog with live progress if the user navigates away and back — but a
    // completed/failed job must be cleared here, otherwise that same effect
    // keeps reopening this already-dismissed dialog on every remount.
    if (groupDownloadJob.status === "completed" || groupDownloadJob.status === "failed") {
      dispatch({ type: GROUP_DOWNLOAD_JOB_RESET });
    }
  };
  const handleClientNameClick = (id) => {
    history.push(`/stats/${id}`);
  };
  if (!user) {
    history.push("/login");
  }

  const handleStartDateChange = (date) => {
    // const formattedDate = date.toISOString().split("T")[0];
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    // const formattedDate = date.toISOString().split("T")[0];
    setEndDate(date);
  };
  // const totalAmount = filteredRows.reduce((total, row) => {
  //   // Ensure that each row has an 'amount' property
  //   if (typeof row.total === "number") {
  //     return total + row.total;
  //   } else {
  //     return total;
  //   }
  // }, 0);
  const salespersonsProps = {
    options: users,
    getOptionLabel: (option) => option.name,
  };
  // }
  // function checkStatus(status) {
  //   return status === "Partial"
  //     ? {
  //         border: "solid 0px #1976d2",
  //         backgroundColor: "#baddff",
  //         padding: "8px 18px",
  //         borderRadius: "20px",
  //       }
  //     : status === "Paid"
  //     ? {
  //         border: "solid 0px green",
  //         backgroundColor: "#a5ffcd",
  //         padding: "8px 18px",
  //         borderRadius: "20px",
  //       }
  //     : status === "Unpaid"
  //     ? {
  //         border: "solid 0px red",
  //         backgroundColor: "#ffaa91",
  //         padding: "8px 18px",
  //         borderRadius: "20px",
  //       }
  //     : "red";
  // }

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  // if (rows.length === 0) {
  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         alignItems: "center",
  //         justifyContent: "center",
  //         flexDirection: "column",
  //         paddingTop: "20px",
  //         margin: "80px",
  //       }}
  //     >
  //       <NoData />
  //       <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>
  //         No Order yet. Click the plus icon to create Order
  //       </p>
  //     </div>
  //   );
  // }
  const clientsProps = {
    options: clients,
    getOptionLabel: (option) => option.agentCode,
  };
  return (
  <div
      style={{
        width: "100%",
        minHeight: isMobile ? "740px" : "470px",
        boxSizing: "border-box",
        padding: isMobile ? "0 8px" : "0 20px",
      }}
    >
      <ThemeProvider theme={colorTheme}>
        <Container
          maxWidth={false}
          disableGutters
          style={{
            width: "100%" ,
            maxWidth: "none",
            paddingTop: "2px",
            paddingBottom: "2px",
            paddingLeft: isMobile ? "0" : "0",
            paddingRight: isMobile ? "0" : "0",
            border: "none",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  label="From"
                  name="FromDate"
                  value={startDate}
                  onChange={handleStartDateChange}
                  required
                  format="dd/MM/yyyy"
                  style={{ maxWidth: isMobile ? "50%" : "100%" }}
                />

                <KeyboardDatePicker
                  label="To"
                  name="EndDate"
                  value={endDate}
                  onChange={handleEndDateChange}
                  required
                  format="dd/MM/yyyy"
                  style={{ maxWidth: "50%" }}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              {user?.result?.userType === "admin" && (
                <FormControl style={{ width: "100px" }}>
                  <InputLabel>Filter:</InputLabel>
                  <Select
                    value={selectedFilter}
                    onChange={(event) => handleFilterChange(event)} // Provide the event object
                  >
                    <MenuItem value="salesperson">Filter by User</MenuItem>
                    <MenuItem value="customer">Filter by Agent</MenuItem>
                    <MenuItem value="FIT">FIT</MenuItem>
                    <MenuItem value="GROUP">GROUP</MenuItem>
                  </Select>
                  {selectedFilter && (
                    <IconButton
                      size="small"
                      style={{
                        marginLeft: "8px",
                        backgroundColor: "transparent",

                        color: "#ef7f1a",
                        borderRadius: "4px",
                      }}
                      onClick={() => {
                        setSelectedFilter("");
                        setSearchQuery("");
                        setSalesperson("");
                        setParty("");
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  )}
                </FormControl>
              )}
              {selectedFilter && (
                <div>
                  {/* Display filtering results or perform filtering logic based on selectedFilter */}
                  {selectedFilter === "salesperson" ? (
                    <ThemeProvider theme={colorTheme}>
                      <Container>
                        {salesperson && (
                          <div
                            style={{
                              display: "flex",
                              marginTop: "20px",
                              gap: "5px",
                              height: "50px",
                            }}
                          >
                            <Typography variant="subtitle1" gutterBottom>
                              {salesperson.name}
                            </Typography>

                            <Button
                              color="primary"
                              size="small"
                              style={{
                                textTransform: "none",
                                backgroundColor: "#ef7f1a",
                                color: "white",
                              }}
                              onClick={() => {
                                setSalesperson(null);
                                setSearchQuery("");
                              }}
                            >
                              Change
                            </Button>
                          </div>
                        )}
                        <div
                          style={
                            salesperson
                              ? { display: "none" }
                              : { display: "block", width: "200px" }
                          }
                        >
                          <Autocomplete
                            {...salespersonsProps}
                            // PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // required={!invoice && true}
                                label="Select User"
                                margin="normal"
                                variant="outlined"

                                // error={touched && !!errors.client}
                                // helperText={touched && errors.client}
                              />
                            )}
                            value={users?.name}
                            onChange={(event, value) => {
                              setSalesperson(value);
                              setSearchQuery(value ? value.name : "");

                              console.log("value: ", value);
                              // handleClientChange();
                            }}
                            // onChange={(event, value) => setClient(value) }
                          />
                        </div>
                      </Container>
                    </ThemeProvider>
                  ) : selectedFilter === "customer" ? (
                    <ThemeProvider theme={colorTheme}>
                      <Container>
                        {party && (
                          <div
                            style={{
                              display: "flex",
                              marginTop: "20px",
                              gap: "10px",
                              height: "50px",
                            }}
                          >
                            <Typography variant="subtitle1" gutterBottom>
                              {party.agentCode}
                            </Typography>

                            <Button
                              color="primary"
                              size="small"
                              style={{
                                textTransform: "none",
                                backgroundColor: "#ef7f1a",
                                color: "white",
                              }}
                              onClick={() => {
                                setParty(null);
                                setSearchQuery("");
                              }}
                            >
                              Change
                            </Button>
                          </div>
                        )}
                        <div
                          style={
                            party
                              ? { display: "none" }
                              : { display: "block", width: "200px" }
                          }
                        >
                          <Autocomplete
                            {...clientsProps}
                            // PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // required={!invoice && true}
                                label="Select Agent/Hotel"
                                margin="normal"
                                variant="outlined"
                                // error={touched && !!errors.client}
                                // helperText={touched && errors.client}
                              />
                            )}
                            value={clients?.name}
                            onChange={(event, value) => {
                              setParty(value);
                              setSearchQuery(value ? value.agentCode : "");

                              // handleClientChange();
                            }}
                            // onChange={(event, value) => setClient(value) }
                          />
                        </div>
                      </Container>
                    </ThemeProvider>
                  ) : null}
                </div>
              )}
              {user?.result?.userType !== "admin" && (
                <ThemeProvider theme={colorTheme}>
                  <Container>
                    {party && (
                      <div
                        style={{
                          display: "flex",
                          marginTop: "20px",
                          gap: "10px",
                          height: "50px",
                        }}
                      >
                        <Typography variant="subtitle1" gutterBottom>
                          {party.agentCode}
                        </Typography>

                        <Button
                          color="primary"
                          size="small"
                          style={{
                            textTransform: "none",
                            backgroundColor: "#ef7f1a",
                            color: "white",
                          }}
                          onClick={() => {
                            setParty(null);
                            setSearchQuery("");
                          }}
                        >
                          Change
                        </Button>
                      </div>
                    )}
                    <div
                      style={
                        party
                          ? { display: "none" }
                          : { display: "block", width: "200px" }
                      }
                    >
                      <Autocomplete
                        {...clientsProps}
                        // PaperComponent={CustomPaper}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            // required={!invoice && true}
                            label="Select Hotel/Agent"
                            margin="normal"
                            variant="outlined"
                            // error={touched && !!errors.client}
                            // helperText={touched && errors.client}
                          />
                        )}
                        value={clients?.name}
                        onChange={(event, value) => {
                          setParty(value);
                          setSearchQuery(value ? value.agentCode : "");

                          // handleClientChange();
                        }}
                        // onChange={(event, value) => setClient(value) }
                      />
                    </div>
                  </Container>
                </ThemeProvider>
              )}

              {loading ? (
                <CircularProgress
                  style={{ marginTop: "20px", marginLeft: "10px" }}
                />
              ) : (
                user?.result?.userType === "admin" && (
                  <>
                  <Button
                    variant="outlined"
                    endIcon={<GetAppIcon />}
                    onClick={createAndDownloadPdf}
                    style={{
                      margin: "16px 0 8px 0",
                    }}
                  >
                    PDF
                  </Button>
                  <Button
                    variant="outlined"
                    endIcon={<GetAppIcon />}
                    onClick={createAndDownloadXlsx}
                    style={{
                      margin: "16px 0 8px 0",
                    }}
                  >
                    Excel
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={handleGroupDownload}
                    disabled={loading || groupLoading || groupDownloadJob.status === "processing"}
                    endIcon={
                      groupLoading ? (
                        <CircularProgress size={18} />
                      ) : (
                        <GetAppIcon />
                      )
                    }
                    sx={{ margin: "16px 0 8px 0" }}
                  >
                    {groupLoading
                      ? "Starting..."
                      : groupDownloadJob.status === "processing"
                      ? "Processing..."
                      : "Group Download"}
                  </Button>
                  </>


                )
              )}
            </div>
          </div>

          <section className={classes.summaryPanel}>
            <h3 className={classes.summaryTitle}>Summary Totals</h3>
            <div className={classes.summaryGrid}>
              {summaryCards.map((card) => (
                <div className={classes.summaryCard} key={card.label}>
                  <div className={classes.summaryLabel}>{card.label}</div>
                  <div
                    className={classes.summaryValue}
                    style={{ color: card.color }}
                  >
                    {summaryCurrency}
                    {toCommas(card.value)}
                  </div>
                </div>
              ))}
            </div>
          </section>

          <TableContainer
            component={Paper}
            elevation={0}
            className={classes.tableContainer}
          >
            <Table
              className={classes.table}
              aria-label="custom pagination table"
            >
              <TableHead>
                <TableRow>
                  <TableCell style={headerStyle}>ID</TableCell>

                  <TableCell style={headerStyle}>Booking Date</TableCell>

                  {/* <TableCell style={headerStyle}>Hotel/Agent</TableCell> */}
                  <TableCell style={headerStyle}>Agent </TableCell>
                  <TableCell style={headerStyle}>Guide Name</TableCell>
                  <TableCell style={headerStyle}>Ref No </TableCell>
                  <TableCell style={headerStyle}>Booking Type</TableCell>
                  <TableCell style={headerStyle}>Nationality</TableCell>
                  <TableCell style={headerStyle}>Hotel</TableCell>
                  
                  <TableCell style={headerStyle}>Notes</TableCell>
                  <TableCell style={headerStyle}>Pax</TableCell>
                  <TableCell style={headerStyle}>Commission</TableCell>
                  <TableCell style={headerStyle}>Expense</TableCell>
                  <TableCell style={headerStyle}>Amount</TableCell>

                  {/* <TableCell style={headerStyle}>Status</TableCell> */}
                  {/* {user?.result?.userType === "admin" && (
                    <TableCell style={headerStyle}>User</TableCell>
                  )} */}

                  <TableCell style={headerStyle}>Edit</TableCell>

                  {user?.result?.userType === "admin" && (
                    <TableCell style={headerStyle}>Delete</TableCell>
                  )}
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredRows.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={user?.result?.userType === "admin" ? 15 : 14}
                      style={{ textAlign: "center", padding: "40px" }}
                    >
                      <NoData />
                      <p style={{ paddingTop: "20px", color: "gray" }}>
                        No records found for selected filters.
                      </p>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredRows.map((row) => (
                    <TableRow key={row._id} className={classes.row}>
                      <TableCell
                        className={classes.bodyCell}
                        style={{ cursor: "pointer" }}
                        onClick={() => openInvoice(row._id)}
                      >
                        {row.invoiceNumber}
                      </TableCell>

                      <TableCell
                        className={classes.bodyCell}
                        style={{ cursor: "pointer" }}
                        onClick={() => openInvoice(row._id)}
                      >
                        {moment(row.date).format("Do MMM YYYY")}
                      </TableCell>

                      <TableCell className={classes.bodyCell}>
                        {row.client ? row.client.agentCode : "Cash"}
                      </TableCell>

                      <TableCell className={classes.bodyCell}>
                        {row.guide || "-"}
                      </TableCell>

                      <TableCell className={classes.bodyCell}>
                        {row.refNum}
                      </TableCell>

                      <TableCell className={classes.bodyCell}>
                        {row.bookingType || "-"}
                      </TableCell>

                      <TableCell className={classes.bodyCell}>
                        {row.nationality}
                      </TableCell>

                      <TableCell className={classes.bodyCell}>
                        {row.hotel}
                      </TableCell>

                      <TableCell className={classes.bodyCell}>
                        {row.notes || "-"}
                      </TableCell>

                      <TableCell className={classes.bodyCell}>
                        {(row.adult || 0) + (row.child || 0)}
                      </TableCell>

                      <TableCell
                        className={`${classes.bodyCell} ${classes.amountCell}`}
                        style={{ color: "#ff6500", cursor: "pointer" }}
                        onClick={() => openInvoice(row._id)}
                      >
                        {row.currency || summaryCurrency} {toCommas(row.commission)}
                      </TableCell>

                      <TableCell
                        className={`${classes.bodyCell} ${classes.amountCell}`}
                        style={{ color: "#e52f4f", cursor: "pointer" }}
                        onClick={() => openInvoice(row._id)}
                      >
                        {row.currency || summaryCurrency} {toCommas(row.expense)}
                      </TableCell>

                      <TableCell
                        className={`${classes.bodyCell} ${classes.amountCell}`}
                        style={{ color: "#0b72ff", cursor: "pointer" }}
                        onClick={() => openInvoice(row._id)}
                      >
                        {row.currency || summaryCurrency} {toCommas(row.total)}
                      </TableCell>

                      <TableCell
                        className={`${classes.bodyCell} ${classes.actionCell}`}
                      >
                        <IconButton onClick={() => editInvoice(row._id)}>
                          <BorderColorIcon style={{ width: "20px", height: "20px" }} />
                        </IconButton>
                      </TableCell>

                      {user?.result?.userType === "admin" && (
                        <TableCell
                          className={`${classes.bodyCell} ${classes.actionCell}`}
                        >
                          <IconButton onClick={() => handleDelete(row._id)}>
                            <DeleteOutlineRoundedIcon
                              style={{ width: "20px", height: "20px" }}
                            />
                          </IconButton>
                        </TableCell>
                      )}
                    </TableRow>
                  ))
                )}
              </TableBody>

              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[
                      10,
                      25,
                      50,
                      100,
                      500,
                      { label: "All", value: -1 },
                    ]}
                    colSpan={6}
                    count={totalInvoices}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: { "aria-label": "rows per page" },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Container>
      </ThemeProvider>
      <GroupDownloadDialog
        open={groupDialogOpen}
        onClose={handleCloseGroupDialog}
      />
    </div>
  );
};

export default Invoices;
